<template>
  <label class="app-textarea" :data-replicated-value="state">
    <textarea v-model="state" class="app-textarea__textarea" :rows="rows" :class="{ center: center }"></textarea>
  </label>
</template>

<script>
export default {
  name: 'app-textarea',
  props: {
    value: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 1,
    },
    center: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    state: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.app-textarea {
  position: relative;

  // https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/

  display: grid;
  flex-grow: 1;
  font-size: 14px;

  word-break: break-word;

  &__textarea {
    width: 100%;
    border: 1px solid #000000;
    border-radius: 5px;
    padding: 10px;
    color: #000000;

    resize: vertical;

    &.center {
      text-align: center;
    }
  }

  &::after,
  textarea {
    grid-area: 1 / 1 / 2 / 2;
  }

  &::after {
    content: attr(data-replicated-value) ' ';

    padding: 10px;

    white-space: pre-wrap;
    word-break: break-word;

    visibility: hidden;
  }
}
</style>
